export const DELAYED_SUCCESS_CONSTANTS = {
    TITLE: "Placing your order...",
    SUBTITLE: "Just a moment while the restaurant confirms your items.",
    LOADER_SIZE: "xLarge" as const,
    SUBTITLE_WIDTH: "250px",
};
